var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-button', { staticClass: "add-button", class: { 'add-button-after': !_vm.loading }, attrs: { "loading": _vm.loading, "type": "text" }, on: { "click": _vm.addResource } }, [_vm.$slots.default ? _vm._t("default") : _vm._e(), _vm._v(" "), _c('svg-icon', _vm._b({ directives: [{ name: "show", rawName: "v-show", value: !_vm.loading, expression: "!loading" }], attrs: { "icon-class": "add_to", "size": 24 } }, 'svg-icon', _vm.iconStyle, false))], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };